module.exports = __webpack_public_path__ + "static/assets/e09ea4feeb789057b53032f167592be0.svg";